"use strict";

(function () {
  function postJson(url, payload) {
    return fetch(url, Object.assign({}, fetchConfig(), {
      body: JSON.stringify(payload)
    }));
  }

  function toInt(value) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  class SuperPumpCartPage {
    constructor(root) {
      this.root = root;
      this.isBusy = false;
      this.peachVariantId = toInt(root.dataset.peachVariantId);
      this.appleVariantId = toInt(root.dataset.appleVariantId);
      this.bindEvents();
    }

    bindEvents() {
      this.root.addEventListener("click", this.handleClick.bind(this), true);
    }

    handleClick(event) {
      var qtyButton = event.target.closest("[data-qty-action]");
      if (qtyButton && this.root.contains(qtyButton)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.handleQuantity(qtyButton);
        return;
      }

      var removeButton = event.target.closest("[data-remove-item]");
      if (removeButton && this.root.contains(removeButton)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.handleRemove(removeButton);
        return;
      }

      var upsellButton = event.target.closest("[data-cart-upsell]");
      if (upsellButton && this.root.contains(upsellButton)) {
        event.preventDefault();
        this.handleUpsell(upsellButton);
        return;
      }

      var subscribeButton = event.target.closest("[data-cart-subscribe]");
      if (subscribeButton && this.root.contains(subscribeButton)) {
        event.preventDefault();
        this.handleSubscribe(subscribeButton);
      }
    }

    async handleQuantity(button) {
      if (this.isBusy || button.disabled) return;

      var line = button.closest("cart-item");
      if (!line) return;

      var input = line.querySelector("[name='quantity']");
      if (!input) return;

      var currentQuantity = toInt(input.value);
      var nextQuantity = button.dataset.qtyAction === "increase" ? currentQuantity + 1 : currentQuantity - 1;
      var variantId = toInt(input.dataset.id);

      if (!variantId || nextQuantity < 0) return;
      await this.updateCart({ [variantId]: nextQuantity });
    }

    async handleRemove(button) {
      if (this.isBusy || button.disabled) return;
      var line = button.closest("cart-item");
      if (!line) return;
      var variantId = toInt(line.dataset.id);
      if (!variantId) return;
      await this.updateCart({ [variantId]: 0 });
    }

    async handleUpsell(button) {
      if (this.isBusy) return;

      var action = button.dataset.action;
      if (action === "add_same") {
        var variantId = toInt(button.dataset.variantId);
        var currentQuantity = toInt(button.dataset.currentQuantity);
        if (!variantId) return;
        await this.updateCart({ [variantId]: currentQuantity + 1 });
        return;
      }

      if (action === "swap_mix_1") {
        await this.replaceCart([
          { id: this.peachVariantId, quantity: 1 },
          { id: this.appleVariantId, quantity: 1 }
        ], window.routes.cart_url);
        return;
      }

      if (action === "swap_mix_2") {
        await this.replaceCart([
          { id: this.peachVariantId, quantity: 2 },
          { id: this.appleVariantId, quantity: 2 }
        ], window.routes.cart_url);
      }
    }

    async handleSubscribe(button) {
      if (this.isBusy) return;

      var variantId = toInt(button.dataset.variantId);
      var quantity = toInt(button.dataset.quantity);
      var planId = toInt(button.dataset.planId);

      if (!variantId || !quantity || !planId) return;

      await this.replaceCart([
        {
          id: variantId,
          quantity: quantity,
          selling_plan: planId
        }
      ], "/checkout");
    }

    async updateCart(updates) {
      try {
        this.setBusy(true);
        await postJson(window.routes.cart_update_url, { updates: updates });
        window.location.reload();
      } catch (error) {
        console.error("Cart update failed", error);
        this.setBusy(false);
      }
    }

    async replaceCart(items, redirectUrl) {
      try {
        this.setBusy(true);

        await fetch("/cart/clear.js", Object.assign({}, fetchConfig()));
        await postJson(window.routes.cart_add_url + ".js", { items: items });

        window.location.href = redirectUrl || window.routes.cart_url;
      } catch (error) {
        console.error("Cart replace failed", error);
        this.setBusy(false);
      }
    }

    setBusy(state) {
      this.isBusy = state;
      this.root.classList[state ? "add" : "remove"]("is-loading");
      this.root.querySelectorAll("button").forEach(function (button) {
        button.disabled = state;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    var cartRoot = document.querySelector("[data-cart-page]");
    if (!cartRoot) return;
    new SuperPumpCartPage(cartRoot);
  });
})();
